'use strict';

const SyncStateView = require('system/ui/view/sync-state');
const Template = require('system/ui/template/diagram-sync-state.hbs');

module.exports = SyncStateView.extend({
    className: 'diagram-sync-state',
    template: Template
});



// WEBPACK FOOTER //
// ./system/ui/view/diagram-sync-state.js